import React from "react"
import Paper from "material-ui/Paper"
import Clear from "../../../components/misc/Clear"
import ImageLoader from "../../../components/misc/ImageLoader"
import EquipmentForm from "./EquipmentForm"
import EquipmentDetailChartSummary from "./EquipmentDetailChartSummary"
import { IEquipmentDocument } from "../../../models"

interface IProps {
    equipment: IEquipmentDocument
    readonly: boolean
}

const styles = {
    ChartWrapper: {
        width: "30%",
        float: "left",
        minWidth: 350
    },
    ChartWrapperExpanded: {
        width: "32%",
        float: "left",
        height: 380,
        padding: "20px 0",
        textAlign: "center",
        minWidth: 350
    },
    Paper: {
        textAlign: "left",
        margin: 20,
        position: "relative",
        overFlow: "hidden"
    },
    UserStats: {
        expanded: {
            textAlign: "center",
            minWidth: "435px",
            width: "38%",
            float: "left",
            background: "#FAFAFA",
            height: 420
        },
        minified: {
            textAlign: "center",
            padding: 20,
            width: "calc((100%  /4)*2)",
            float: "left",
            background: "#e7e7e7"
        }
    }
}

const EquipmentDetailsSummary: React.SFC<IProps> = (props: IProps) => {
    const { equipment } = props
    const EquipmentBlock = (
        <div style={{ textAlign: "center", float: "left", width: "30%" }}>
            <h2 style={{ textTransform: "uppercase" }}>{equipment && equipment.Name}</h2>
            {equipment && equipment.ImageId &&
                <Paper zDepth={1} style={{ display: "inline-block" }}>
                    <ImageLoader url={equipment.ImageS3Url} fixedHeight={300} src={"/users/profileimage/" + equipment.ImageS3Url} />
                </Paper>
            }
        </div>
    )

    const EquipmentStats = (
        <div style={styles.UserStats.expanded}>
            <Clear />
            <div
                style={{
                    textAlign: "left",
                    position: "relative",
                    bottom: 0,
                    marginTop: 0
                }}
            >
                <EquipmentForm equipment={equipment} readonly={props.readonly} />
            </div>
            <Clear />
        </div>
    )

    const EquipmentChart = (
        <div className="WrapperEquipmentDetailChartSummary" style={styles.ChartWrapperExpanded}>
            <EquipmentDetailChartSummary />
        </div>
    )

    return (
        <div className="UserDetailsSummary">
            <Paper zDepth={1} style={{ ...styles.Paper, minWidth: 1300 }}>
                {EquipmentBlock}
                {EquipmentStats}
                {EquipmentChart}
                <Clear />
            </Paper>
        </div >
    )
}

export default EquipmentDetailsSummary
